"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class UnifiedSearchTileMapper {
  defaultTag = {
    bestValue: {
      tagName: {
        Text: 'Best Value'
      },
      id: 'best-value'
    }
  };
  constructor(args) {
    this.props = args.props ?? args.componentProps;
    this.resultType = args.resultType;
    this.componentType = `${args.componentType}`;
    this.trackTag = this.props.flagText;
    if (!this.props.productTags) {
      this.props.productTags = this.composeTags(this.props.tags);
    }
    const priceProps = this.props.priceLockup?.price;
    if (priceProps && priceProps?.includes('span')) {
      this.props.priceLockup.price = this.extractPrice(priceProps);
    }
  }
  composeTags(tags) {
    if (!tags || tags?.length === 0) {
      return [this.defaultTag.bestValue];
    }
    return tags.map(key => ({
      tagName: {
        Text: key
      },
      id: key
    }));
  }
  extractPrice(htmlString) {
    const match = htmlString.match(/<span[^>]*class=["']no-wrap-text["'][^>]*>\s*(\$?\d+(?:\.\d{2})?)\s*<\/span>/i);
    return match ? match[1] : null;
  }
}
var _default = exports.default = UnifiedSearchTileMapper;